module.exports = __webpack_public_path__ + "img/0-131.77ad1284.jpg";